import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "../utils";
import { getAutomationDataAttr } from "../../utils/automationUtils";

import "./styles.scss";

export const Card = ({ children, className, testId, ...props }) => (
  <div
    className={createClassNameString(["apti-CL apti-Card", className])}
    {...getAutomationDataAttr(testId)}
    {...props}
  >
    {children}
  </div>
);

Card.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
  className: PropTypes.string,
};

Card.defaultProps = {
  children: <></>,
  className: undefined,
};
